import api from '../../api';
import type { AppDispatch, ClusterOption, GetState } from '../../types/redux';
import { editorError, editorLoading, setEditorClusterOptions } from './actions';

type ResolveCallback<T = unknown> = (value: T) => void;
type RejectCallback = (error: unknown) => void;

export const tabNameSaveOnCloud =
  (_tab_id: string, _name: string, _isPara?: boolean) =>
  async (_dispatch: AppDispatch, _getState: GetState): Promise<null> => {
    return null;
  };

export const fetchClusterOptions =
  (
    showLoader: boolean = true,
    resolve?: ResolveCallback<ClusterOption[]>,
    _reject?: RejectCallback
  ) =>
  async (dispatch: AppDispatch, _getState: GetState): Promise<void> => {
    if (showLoader) {
      dispatch(editorLoading(true));
    }

    try {
      // Actual API call (commented out for local development)
      const response = await api.get('queryservices');
      const options: ClusterOption[] = (
        (response.data.items || []) as Array<{
          name: string;
          status: string;
          [key: string]: unknown;
        }>
      )
        .filter((item) =>
          ['Suspended', 'Running', 'Ready', 'Updating', 'Resuming'].includes(item.status)
        )
        .map((item) => ({
          ...item,
          id: item.name,
          uuid: item.name,
          name: item.name,
          cluster_name: item.name,
          status: item.status,
          load_balancer_url: `http://localhost:8080`,
          host: `http://localhost:8080`,
        }));
      dispatch(setEditorClusterOptions(options));
      resolve?.(options);
    } catch (error) {
      console.error('Error fetching cluster options:', error);
      dispatch(editorError(error));
      // reject(error);
    } finally {
      if (showLoader) {
        dispatch(editorLoading(false));
      }
    }
  };

// Cluster functionality moved from cluster reducer
export const resumeCluster =
  (cluster_uuid: string, resolve?: ResolveCallback, reject?: RejectCallback) =>
  async (dispatch: AppDispatch, _getState: GetState): Promise<void> => {
    // dispatch(editorLoading(true));
    const url = `queryservices/${cluster_uuid}/resume`;
    api.post(url, null).then(
      (res) => {
        resolve?.(res);
      },
      (errorRes) => {
        // handle error
        dispatch(editorError(errorRes));
        reject?.(errorRes);
      }
    );
    // .finally(() => {
    //     dispatch(editorLoading(false));
    // });
  };
